import { TFunction, useTranslation } from '@lyearn/i18n';
import { FormControlLabel, Radio, Stack } from '@lyearn/ui';
import { UpdateEventStatusTypeEnum } from '@/types/schema';

const CLASSES = {
  label: 'body-short-02',
  root: 'ms-0 me-0',
};

const getItems = (t: TFunction) => [
  {
    id: UpdateEventStatusTypeEnum.Current,
    label: t('Events:RecurringSession.ThisSession'),
  },
  {
    id: UpdateEventStatusTypeEnum.Upcoming,
    label: t('Events:RecurringSession.ThisAndFollowingSessions'),
  },
  {
    id: UpdateEventStatusTypeEnum.All,
    label: t('Events:RecurringSession.AllUpcomingSessions'),
  },
];

function UpdateEventStatusType({
  updateType,
  onChange,
}: {
  updateType: UpdateEventStatusTypeEnum;
  onChange: (val: UpdateEventStatusTypeEnum) => void;
}) {
  const { t } = useTranslation();
  const items = getItems(t);

  return (
    <Stack className="mb-40 space-y-16 px-8" direction="col">
      {items.map((item) => (
        <FormControlLabel
          key={item.id}
          checked={item.id === updateType}
          classes={CLASSES}
          control={<Radio className="me-12" size="small" />}
          label={item.label}
          onChange={() => onChange(item.id)}
        />
      ))}
    </Stack>
  );
}

export default UpdateEventStatusType;
